import { StatList } from '../../../../../_components/StatList'
import { FormField } from '../../../../../_components/Forms/FormField'
import { updateInvoiceSchedule } from '../../../../../_services/lender.service'
import React, { useEffect, useRef } from 'react'
import { notificationActionHooks } from '../../../../../_actionHooks'

export const ScheduleTotals = ({
  invoiceSchedule,
  batchTotal,
  fundedTotal,
  expectedBatchTotal,
  setExpectedBatchTotal,
  isClientView,
  disabled,
}) => {
  let businessIdRef = useRef()

  let expectedTotal = expectedBatchTotal

  const scheduleId = invoiceSchedule.id
  const businessId = invoiceSchedule.business_id
  const businessName = invoiceSchedule.business_name

  // Focus the business field on load
  useEffect(() => {
    if (businessIdRef.current && !businessId) {
      businessIdRef.current.focus()
    }
  })

  const showNotification = notificationActionHooks.useShowNotification()
  const cancelEditingOnError = (error) => {
    showNotification({
      type: `error`,
      message: error,
      id: `create-invoice-fail`,
    })
    return false
  }

  return (
    <StatList
      items={[
        !isClientView && {
          label: 'Client',
          type: null,
          value: (
            <FormField
              className={'read-only-styles no-input-styles'}
              disabled={true}
              type="text"
              value={businessName}
            />
          ),
        },
        {
          label: 'Batch Total',
          tooltip: 'Manually enter schedule total to ensure balance is same as auto-calculated schedule total.',
          value: (
            <FormField
              disabled={disabled}
              onBlur={async () => {
                setExpectedBatchTotal(expectedTotal)
                //a bit overkill on the null checking to help with known merge conflict that will arise
                //TODO: When creating the schedule if this has been filled out save it
                if (scheduleId) {
                  await updateInvoiceSchedule(scheduleId, {
                    expected_total_value: expectedTotal,
                  }).catch((error) => cancelEditingOnError(error))
                }
              }}
              onChange={(numVal) => {
                expectedTotal = numVal
              }}
              type="currency"
              value={expectedBatchTotal}
            />
          ),
        },
        {
          label: 'Invoices Total',
          value: (
            <FormField
              className={'read-only-styles no-input-styles'}
              disabled={true}
              type="currency"
              value={batchTotal}
            />
          ),
        },
        !isClientView && {
          label: 'Fund Invoice Total',
          value: (
            <FormField
              className={'read-only-styles no-input-styles'}
              disabled={true}
              type="currency"
              value={fundedTotal}
            />
          ),
        },
      ]}
      layout="summary"
    />
  )
}
